<template>
  <div class="login">
    <div class="wrapper">
      <h1 class="brand">CTP</h1>
      <div class="box">
        <b-input v-model="user" placeholder="user" />
        <b-input type="password" v-model="password" placeholder="password" />
        <b-button variant="info" @click="login()">Login</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;

export default {
  data() {
    return {
      user: "",
      password: "",
    };
  },
  methods: {
    async login() {
      let url = `${SERVER_URL}/login`;
      let resp = null;
      try {
        resp = await axios.post(url, {
          user_id: this.user,
          password: this.password,
        });
        this.$cookies.set("token", resp.data.token);
        this.$cookies.set("user_id", resp.data.user_id);

        this.$store.state.questionmeta.owner = this.user;

        this.$router.replace("/admin/book/list");
      } catch (err) {
        alert(err.response.data.msg);
      }

      // this.$cookies.set("user_id", "handpape");
      // this.$router.replace("/workspace");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
h1.brand {
  font-size: 5em;
  background: $gradient1;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.login .wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  div.box {
    border-style: solid;
    border-image: $gradient1;
    border-image-slice: 1;
    border-image-width: 10px 0 10px 0;

    min-height: 300px;
    min-width: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    input {
      width: 200px;
      margin-bottom: 5px;
    }
    input:nth-child(2) {
      margin-bottom: 20px;
    }
  }
}
</style>